
















import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'GuideImageText',
  props: {
    direction: {
      type: String as PropType<'horizonal' | 'vertical'>,
      required: false,
      default: 'horizonal' as const,
    },
  },
});
